import React, { useState } from "react";
import { toast } from "react-toastify";
import "./RejectBlogModal.css";

const RejectBlogModal = ({ onClose, onSubmit, blogTitle }) => {
  const [reason, setReason] = useState("");
  // This state will manage switching between the form and the confirmation view
  const [showConfirmation, setShowConfirmation] = useState(false);

  // This function now just validates the reason and moves to the confirmation view
  const handleSubmitReason = () => {
    if (!reason.trim()) {
      toast.warn("Rejection reason cannot be empty.");
      return;
    }
    setShowConfirmation(true);
  };

  // This new function handles the final confirmed submission
  const handleConfirmRejection = () => {
    onSubmit(reason);
  };

  return (
    <div className="modal-overlay">
      {!showConfirmation ? (
        <>
          {/* <button className="modal-close-icon" onClick={onClose}>
              <i className="bi bi-x-lg"></i>
            </button>
            <div className="reject-circle">
              <i className="bi bi-x-lg"></i>
            </div>
            <h3>Reason for Rejection</h3>
            <p>You are rejecting the: <strong>{blogTitle || 'N/A'}</strong></p>
            <textarea
              rows="4"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Please provide a clear reason..."
            ></textarea>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={onClose}>
                Cancel
              </button>
              <button className="btn-submit" onClick={handleSubmitReason}>
                Submit Rejection
              </button>
            </div> */}
          <div className="modal">
            <div className="modal_header">
              <div className="modal_header_text">
                <h2>Summary</h2>
              </div>
              <div className="modal_cross_icon" onClick={onClose}>
                <i className="bi bi-x-lg"></i>
              </div>
            </div>
            <div className="modal_body">
              <div className="form_input_wraper_widget">
                <label className="label">Summary</label>
                <textarea
                  className="form-control"
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Please provide a clear reason..."
                  rows={5}
                ></textarea>
              </div>
            <div className="d-flex justify-content-center">
              <button className="delete_approve_btn" onClick={handleSubmitReason}>
                Submit Rejection
              </button>
              <button className="delete_reject_btn" onClick={onClose}>
                Cancel
              </button>
            </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="delete-modal p-relative">
            <h2>Are you sure?</h2>
            <p>Please confirm you want to reject this blog.</p>
            <p className="reson-text">
             (<strong>Reason:</strong> "{reason}")
            </p>
            <div className="modal-actions">
              <button className="delete_approve_btn" onClick={handleConfirmRejection}>
                Confirm Rejection
              </button>
              <button
                className="delete_reject_btn"
                onClick={() => setShowConfirmation(false)}
              >
                Back
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default RejectBlogModal;
